import { getPageCluster } from '@shared/domain/PageCluster.ts';
import type { KnownTrackingLabels } from '@shared/tracking/TrackingLabels';

export function getPageViewTracking(historic: boolean, experimentIds: string[] = []) {
    const pageCluster = getPageCluster() || 'UNKNOWN';

    const pageViewTracking: Partial<KnownTrackingLabels> = {
        san_ListEventType: 'tilelistview',
        ot_PageCluster: pageCluster,
    };

    if (historic) pageViewTracking.san_Interaction = 'browser_navigation';

    if (experimentIds.length) {
        pageViewTracking['wk.san_ReptileExperimentSegment'] = experimentIds;
    }

    return pageViewTracking;
}
